// Add your custom JS here.







import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSRulePlugin);



window.onload = function () {
    //if (window.innerWidth > 68) {
    //  console.log("Obrazovka je větší než tablet.");

    if (document.querySelector('.mainpage-banner')) {

        const element = document.querySelector('.mainpage-banner');
        //  const afterStyles = window.getComputedStyle(element, '::after');
        const beforeStyles = window.getComputedStyle(element, '::before');
        //let beforeRule = ".dron"; // Třída, kterou animujeme
        // const beforeRule = ".dron";
        if (beforeStyles.content && beforeStyles.content !== 'none') {
            const beforeRule = CSSRulePlugin.getRule(".mainpage-banner::before");


            const targetElement = document.querySelector(".mainpage-banner");
            let elementHeight = targetElement.offsetHeight;
            // console.log(elementHeight);
            elementHeight /= 2;
            if (window.innerWidth < 768) {
                elementHeight /= 3;
                //console.log(elementHeight);
            }

            // Scrollovací animace pro beforeRule (".dron")
            gsap.to(beforeRule, {
                scrollTrigger: {
                    trigger: ".mainpage-banner--bg",
                    start: "top 0%",
                    end: `+=${elementHeight}`,
                    scrub: true,
                    pin: true,
                    //markers: true,    // Zobrazí vizuální start/end markery


                },
                top: "0%", // Posun při scrollování
                left: "5%",
                scale: 0,
                //  backgroundSize: "0px auto",       // Zmenšení při scrollování
                //opacity: 0.5,
                ease: "none",

                //duration: 1.5,    // Doba animace v sekundách
                ease: "power.out", // Zpomalovací křivka
            });
        }
    }

}
if (document.querySelector('label[for="datum"]')) {
    document.querySelector('label[for="datum"]').textContent = 'Termín';

}





import "./googlereviews.js";
import "./swiper_lector.js"; // swiperjs pro HP vypis lektoru
import "./swiper_products.js"; // swiperjs pro produkty
import "./swiper_whattheysay.js"; // swiperjs pro reference
import "./swiper_djishopmasarycka.js"; // swiperjs pro reference
import "./number-ride.js";
import "./singlepage-lector.js";
import "./scrool.js";
import "./woocommerce.js";

/*
const background = document.querySelector(".mainpage-banner--bg");
const backgroundShapes = document.querySelector(".mainpage-banner");
const backgroundShapes2 = document.querySelector(".mainpage-banner-shape");
const text = document.querySelector(".mainpage-banner--left--content");
//const desc = document.querySelector(".mainpage-banner--block--title");

document.addEventListener("mousemove", (e) => {
    let x = (((e.clientX / window.innerWidth - 0.5) * 30) - 15); // Rozsah -20 až +20
    let y = (((e.clientY / window.innerHeight) * 15) - 15); // Rozsah 0 až 20
    let xx = ((e.clientX / window.innerWidth - 0.5) * 10); // Rozsah -20 až +20
    let yy = ((e.clientY / window.innerHeight - 0.5) * 10); // Rozsah 0 až 20
    background.style.backgroundPosition = `${x}px ${y}px`;
    // backgroundShapes.style.backgroundPosition = `${2 * x}px ${2 * y}px`, `${2 * x}px ${2 * y}px`;
    text.style.transform = `translate(${-x}px, ${-y}px)`;



    backgroundShapes2.style.backgroundPosition = `${50 + xx}% ${5 + yy}%`; // Posun vzhledem k centru
    backgroundShapes.style.backgroundPosition = `${9 - (xx * 1.2)}% ${62 - (yy * 1.2)}%`; // Posun vzhledem k centru


});


*/

document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.mainpage-banner')) {
        const background = document.querySelector(".mainpage-banner--bg");
        const backgroundShapes = document.querySelector(".mainpage-banner-shape");
        const backgroundShapes2 = document.querySelector(".mainpage-banner");
        const text = document.querySelector(".mainpage-banner--left--content");

        // Získání výchozích hodnot jen jednou (nižší zátěž než volání při každém snímku)
        const originalBgPos = window.getComputedStyle(background).backgroundPosition.split(" ");
        const originalShapesPos = window.getComputedStyle(backgroundShapes).backgroundPosition.split(" ");
        const originalShapes2Pos = window.getComputedStyle(backgroundShapes2).backgroundPosition.split(" ");

        let targetX = 0, targetY = 0; // Cílové hodnoty
        let lastX = 0, lastY = 0; // Poslední aktualizované hodnoty
        const threshold = 2; // Minimální změna v px, než se efekt aktualizuje
        let isAnimating = false; // Optimalizace pro `requestAnimationFrame`

        // Uchováváme hodnoty přímo v proměnných, ne v CSS
        let x = 0, y = 0;



        document.addEventListener("mousemove", (e) => {
            let newX = (((e.clientX / window.innerWidth - 0.5) * 30) - 15);
            let newY = (((e.clientY / window.innerHeight) * 15) - 15);

            if (Math.abs(newX - targetX) > threshold || Math.abs(newY - targetY) > threshold) {
                targetX = newX;
                targetY = newY;

                // Pokud animace neběží, spustíme ji
                if (!isAnimating) {
                    isAnimating = true;
                    requestAnimationFrame(animate);
                }
            }
        });

        function animate() {
            x += (targetX - x) * 0.1;
            y += (targetY - y) * 0.1;

            // Pokud se hodnota opravdu změnila, nastavíme ji (zabraňuje zbytečnému nastavování stylů)
            if (Math.abs(x - lastX) > 0.1 || Math.abs(y - lastY) > 0.1) {
                lastX = x;
                lastY = y;

                background.style.backgroundPosition = `calc(${originalBgPos[0]} + ${x}px) calc(${originalBgPos[1]} + ${y}px)`;
                backgroundShapes2.style.backgroundPosition = `calc(${originalShapes2Pos[0]} - ${x}px) calc(${originalShapes2Pos[1]} - ${y}px)`;
                backgroundShapes.style.backgroundPosition = `calc(${originalShapesPos[0]} + ${x * 3}px) calc(${originalShapesPos[1]} + ${y * 3}px)`;

                let xx = x * 0.33;
                let yy = y * 0.33;
                text.style.transform = `translate(${-xx}px, ${-yy}px)`;
            }

            // Pokud se hodnota změnila, pokračujeme v animaci, jinak ji ukončíme
            if (Math.abs(targetX - x) > 0.1 || Math.abs(targetY - y) > 0.1) {
                requestAnimationFrame(animate);
            } else {
                isAnimating = false;
            }
        }
    }

});



window.addEventListener("load", function () {
    if (window.location.hash) {
        let target = document.querySelector(window.location.hash);
        if (target) {
            setTimeout(() => {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 100);
        }
    }
});

document.addEventListener("click", function (event) {
    if (event.target.classList.contains("close-notice-btn")) {
        const noticeWrapper = event.target.closest(".woocommerce-notices-wrapper");
        if (noticeWrapper) {
            noticeWrapper.innerHTML = '';
            console.log('Notifikace uzavřena');
        }
    }
});

